export const AWARD = "AWARD";
export const AWARD_SUCCESS = "AWARD_SUCCESS";
export const AWARD_FAILED = "AWARD_FAILED";

export const ADD_AWARD = "ADD_AWARD";
export const ADD_AWARD_SUCCESS = "ADD_AWARD_SUCCESS";
export const ADD_AWARD_FAILED = "ADD_AWARD_FAILED";

export const UPDATE_AWARD = "UPDATE_AWARD";
export const UPDATE_AWARD_SUCCESS = "UPDATE_AWARD_SUCCESS";
export const UPDATE_AWARD_FAILED = "UPDATE_AWARD_FAILED";